import { apiGet, apiPut, apiDelete, apiPostMultipart, API_BASE } from '@/utils/api';

export interface PlatformSettings {
  id: string;
  companyName: string;
  companyLogo: string | null;
  contactPhone: string;
  contactEmail: string;
  createdAt: string;
  updatedAt: string;
}

export interface UpdatePlatformSettingsDto {
  companyName?: string;
  companyLogo?: string;
  contactPhone?: string;
  contactEmail?: string;
}

/**
 * Get platform settings (public - for suspension page)
 */
export const getPlatformSettings = async (): Promise<PlatformSettings> => {
  return apiGet<PlatformSettings>('/platform-settings');
};

/**
 * Get platform settings without auth (for suspension page when user is not logged in)
 */
export const getPlatformSettingsPublic = async (): Promise<PlatformSettings> => {
  const response = await fetch(`${API_BASE}/platform-settings`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error('Failed to fetch platform settings');
  }

  return response.json();
};

/**
 * Update platform settings (Super Admin only)
 */
export const updatePlatformSettings = async (
  dto: UpdatePlatformSettingsDto
): Promise<PlatformSettings> => {
  return apiPut<PlatformSettings>('/platform-settings', dto);
};

/**
 * Upload platform logo (Super Admin only)
 */
export const uploadPlatformLogo = async (
  file: File
): Promise<{ message: string; data: PlatformSettings }> => {
  const formData = new FormData();
  formData.append('logo', file);
  return apiPostMultipart<{ message: string; data: PlatformSettings }>(
    '/platform-settings/logo',
    formData
  );
};

/**
 * Delete platform logo (Super Admin only)
 */
export const deletePlatformLogo = async (): Promise<{ message: string; data: PlatformSettings }> => {
  return apiDelete<{ message: string; data: PlatformSettings }>('/platform-settings/logo');
};
